import { useQuery } from "@apollo/client";
import { GET_LISTING_STATISTICS } from "@/graphql/queries/listing";
import { useRouter } from "next/router";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { InitialResolver } from "@/lib/use.middlewares";
import css from "./.module.scss";
import Head from "next/head";
import Icon from "@/components/icon";
import { GET_LISTING_VIEWS } from "@/graphql/queries/find.listings";

const fields = [
  { key: "views", label: { en: "Views", ar: "المشاهدات" } },
  { key: "impressions", label: { en: "Impressions", ar: "الانطباعات" } },
  { key: "leads", label: { en: "Leads", ar: "التواصل" } },
  { key: "calls", label: { en: "Calls", ar: "المكالمات" } },
  { key: "answers", label: { en: "Answers", ar: "المكالمات المجابة" } },
  { key: "whatsapp", label: { en: "Whatsapp", ar: "الواتساب" } },
  { key: "screens", label: { en: "Screenshots", ar: "لقطات الشاشة" } },
  { key: "msgs", label: { en: "Messages", ar: "الرسائل" } },
  { key: "shared", label: { en: "Shared", ar: "المشاركات" } },
  { key: "favorited", label: { en: "Favorited", ar: "المفضلة" } },
  { key: "location_clicks", label: { en: "Location Clicks", ar: "الموقع" } },
  { key: "play_video", label: { en: "Play Video", ar: "تشغيل الفيديو" } },
];
const defaultStats = fields
  .filter((i) => i.key !== "views")
  .reduce(
    (acc, field) => ({
      ...acc,

      [field.key]: "-",
    }),
    { views: "" },
  );
export default function ListingsStatistics() {
  const router = useRouter();
  const { token, user } = useAuthState();
  const hasAqarPlus = user?.active_aqar_plus_user;
  const { data } = useQuery(GET_LISTING_STATISTICS, {
    skip: !token || !router.query.listing_id,
    context: { token },
    variables: {
      id: router.query.listing_id,
    },
  });
  const { data: viewsData } = useQuery(GET_LISTING_VIEWS, {
    skip: token || !router.query.listing_id,
    context: { token },
    variables: {
      id: router.query.listing_id,
    },
  });

  const counters = hasAqarPlus
    ? {
        ...(data?.Listing?.full_stats?.counters || {}),
      }
    : defaultStats;

  if (!counters.views) {
    counters.views = viewsData?.Listing?.views;
  }
  return (
    <div className={css.statistics}>
      <Head>
        <title>الإحصاءات التفصيلية للإعلان</title>
      </Head>
      <h1>الإحصاءات التفصيلية للإعلان</h1>
      <div className={css.list}>
        {fields.map((field) => (
          <div key={field.key}>
            <p>{field.label.ar}</p>
            <p>{counters[field.key] || 0}</p>
          </div>
        ))}
      </div>
      {!hasAqarPlus ? (
        <button
          onClick={() => router.push("/aqar-plus")}
          className={css.plusButton}
        >
          <Icon width={20} height={20} name="Aqar_plus" />
          إشترك لإظهار جميع الإحصائيات
        </button>
      ) : null}
    </div>
  );
}
ListingsStatistics.getInitialProps = InitialResolver();
